import CONTRATO_PROGRAMAS_OBRA from '@/graphql/querys/administracion/contratos/programa/contratoProgramasObra.gql';

export default {
  methods: {
    calcularDiferenciaEnDiasCostoDirecto(fechaInicio, fechaTermino) {
      const nuevaFechaInicio = new Date(`${fechaInicio} 00:00:0`);
      const nuevaFechaTermino = new Date(`${fechaTermino} 00:00:0`);
      // Calcular
      const diferenciaMiliSegundos = Math.abs(nuevaFechaTermino - nuevaFechaInicio);
      const diferenciaDias = Math.ceil(diferenciaMiliSegundos / (1000 * 60 * 60 * 24));

      return (diferenciaDias + 1);
    },
    sumarMontoAcumuladoCostoDirecto(programadoAnteriror) {
      if (!programadoAnteriror) return 0;
      return this.$ObjSumar(programadoAnteriror, 'monto');
    },
    mixCalcularProgramaCostoDirecto(fecha) {
      let total = 0;

      if (!fecha) {
        return {
          porcentaje: 0,
          importe: 0,
          diasTranscuridos: 0,
        };
      }
      // Fecha del avance
      const alFecha = new Date(`${fecha} 00:00:0`);
      // Comprobar que que exista un programa de obra
      if (this.mixProgramasObrasCostoDirecto.length <= 0) return 0;

      // Seleccionar el primer programa del listado de programas de obra del contrato
      const [programaUno] = this.mixProgramasObrasCostoDirecto;

      const diasTranscuridos = this.calcularDiferenciaEnDiasCostoDirecto(
        this.mixGetProgramaCostoDirecto[0].fechaInicio,
        fecha,
      );

      // Acumulado del programa
      const programaAcumulado = programaUno.programa
        .filter((programa) => new Date(programa.fechaTermino) <= alFecha);

      // Importe acumulado
      const importeAcumulado = this.sumarMontoAcumuladoCostoDirecto(programaAcumulado);

      // Programa actual
      const programadoActual = programaUno.programa
        .filter((programa) => alFecha >= new Date(`${programa.fechaInicio} 00:00:0`)
      && alFecha < new Date(`${programa.fechaTermino} 00:00:0`));

      // Si no hay programado actual, entonces regresas el 100%
      // y, el importe acumulado actual
      if (programadoActual.length <= 0) {
        total = (importeAcumulado);

        return {
          porcentaje: this.$obtenerImporteDosDecimales((
            (total / this.montoPrograma) * 100)),
          importe: this.$obtenerImporteDosDecimales(total),
          diasTranscuridos,
        };
      }

      // Cantidad de dias ejecutados a la fecha
      const diasEjecutados = this.calcularDiferenciaEnDiasCostoDirecto(
        programadoActual[0].fechaInicio, fecha,
      );

      // Cantidad de dias del periodo
      const diasDelPeriodo = this.calcularDiferenciaEnDiasCostoDirecto(
        programadoActual[0].fechaInicio,
        programadoActual[0].fechaTermino,
      );

      // Importe diario
      const importeDiario = (programadoActual[0].monto / diasDelPeriodo);

      // Importe ejecutado del periodo
      const importeEjecutadoDelPeriodo = (importeDiario * diasEjecutados);

      // Importe ejecutado
      const importeEjecutado = (importeAcumulado + importeEjecutadoDelPeriodo);

      total = importeEjecutado;

      // Porcentaje de avace
      const porcentajeProgramado = ((total / this.montoPrograma) * 100);

      // Regresar el porcentaje de avance programado y el importe ejecutado a la fecha
      return {
        porcentaje: this.$obtenerImporteDosDecimales(porcentajeProgramado),
        importe: this.$obtenerImporteDosDecimales(total),
        diasTranscuridos,
      };
    },
  },
  apollo: {
    contratoProgramasObra: {
      query: CONTRATO_PROGRAMAS_OBRA,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  computed: {

    mixProgramasObrasCostoDirecto() {
      // Si no existe programa de obra de la estimacion ni del contrato regresa array vacío
      if (!this.estimacion.programa && !this.contratoProgramasObra) return [];

      // Si existe el programa de obra de la estimación con al menos un elemento, lo regresa
      if (this.estimacion.programa.length >= 1) return [{ programa: this.estimacion.programa }];

      // Si no existe el programa de obra del contrato
      // y el array del prog de la estimación esta vacío, regresa array en blanco
      if (!this.contratoProgramasObra) return [];

      // En caso de no haber regresado el programa de obra de la estimación, regresa el del contrato
      return this.contratoProgramasObra;
    },
    mixGetProgramaCostoDirecto() {
      if (!this.contratoProgramasObra || this.mixProgramasObrasCostoDirecto.length <= 0) return [];

      // Destructurar el primer progama
      const [{ programa }] = this.mixProgramasObrasCostoDirecto;

      // Suma de los montos
      let suma = 0;

      return programa
        // Ordernar el programa por fecha de termino
        .sort((a, b) => new Date(`${a.fechaTermino} 00:00:0`) - new Date(`${b.fechaTermino} 00:00:0`))
        // Calcular el porcentaje de avance
        .map((item) => {
          // Sumar el monto anterior con el monto actual
          suma += item.monto;

          // Regresar el objeto con el calculo de avance
          return {
            ...item,
            // Calcular porcentaje de avance programado
            avance: this.$numberRound((suma / this.montoPrograma) * 100),
          };
        });
    },
  },
};
